import { render, staticRenderFns } from "./SubjectRegisterRoutes.vue?vue&type=template&id=3f7e0f26"
import script from "./SubjectRegisterRoutes.vue?vue&type=script&lang=js"
export * from "./SubjectRegisterRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports